import ApiService from '@/core/services/api.service';

export const CustomerTypeService = {
  getAll(params = {}) {
    return ApiService.query('v1/customer-types', { params });
  },

  getById(id) {
    return ApiService.get(`v1/customer-types/${id}`);
  },

  selectAll(params = {}) {
    return ApiService.query('v1/customer-types/select', { params });
  },

  create(data) {
    return ApiService.post('v1/customer-types', data);
  },

  update(id, data) {
    return ApiService.put(`v1/customer-types/${id}`, data);
  },

  delete(id) {
    return ApiService.delete(`v1/customer-types/${id}`);
  },

  updateActiveStatus(id, data) {
    return ApiService.patch(`v1/customer-types/${id}/active-status`, data);
  },
};
